export default __webpack_public_path__ + "static/media/art_btn.745cfbe3.png";